module.exports = __webpack_public_path__ + "img/spin_btn.50b3f5b5.png";